module.exports = __webpack_public_path__ + "static/media/phone.9396fe3b.png";